import FormsHelper from "./shared";
import "./styles/_main.scss";
//New
const tHelper = new FormsHelper();
//set
global.forms = tHelper;
window.forms = tHelper;
//Register
host.plugins.register({
    // #region Vars
    name: "288a.web.forms",
    // #endregion
    // #region Register
    register() {
        //Global
        host.app.config.globalProperties.$forms = tHelper;
        //Components
        host.components.registerAll(require.context('./views', true, /(?<!views)\.vue$/));
    },
    // #endregion
});
